'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _EmbedContent = require('./EmbedContent');

var _EmbedContent2 = _interopRequireDefault(_EmbedContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@spp/ui-embed-content')(_EmbedContent2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-embed-content/lib/cjs/index.js
 ** module id = 508
 ** module chunks = 1
 **/